import { React ,useState,useEffect} from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RegistrationForm from "../components/registrationForm";

import Footer from "../components/layouts/footer";
import { MainPageHead } from "../components/helpful";

  /**
   * Renders the registration form.
   * 
   * This component displays the registration form and its associated text. It
   * also handles the consent checkbox and the submission of the form.
   * 
   * @returns {JSX.Element} The rendered registration form.
   * @author lionel ghogue ngondeke <lionelladrog@gmail.com>
   */
export default function Register() {

  const [isDisabled, setIsDisable] = useState(true);
  const [islocked, setIsLocked] = useState(false);

  useEffect(() => {
    document.body.addEventListener('click', () => {
      if(isDisabled){
        setIsLocked(true);
      }else{
        setIsLocked(false);
      }
    });
  }, [isDisabled]);
  
  const handleDisabled=()=>{
    if(isDisabled){
      setIsDisable(false);
    }else{
      setIsDisable(true);
    }
  }
  
  return (
    <div className="login-bg">
      <div className="row black-filter">
        <Row className="offset-md-2 offset-sm-2 offset-lg-2 g-4">
          <Col
            className="col-12 col-sm-3 col-lg-3 "
            id="main-form-block"
          >
             <MainPageHead />
            <div className="" id="register-wrapper">
             
              <div > 
                <div className={`text-center `}>
                  <h5 className="text-uppercase">Sign up</h5>
                  <p className="size-small py-0">
                  Please note that this portal is reserved for tourism professionals (Tour Operators, Travel Agents, Incentive agencies...) who work with Beachcomber Hotels.
                  </p>
                  <div>
                    <div className={`registration-consent ${islocked?'islocked':''}`}>
                      This form collects your name, contact number and email
                      address so that our support team can communicate with you
                      and provide assistance. Please check our Privacy Policy to
                      see how we protect and manage your submitted data. Your
                      choices and data can be edited at any time using the
                      Account Management Pages.
                      <div className="row ">
                        <label htmlFor="consent" className="">
                          <input
                            type="checkbox"
                            id="consent"
                            name="consent"
                            className=""
                            onClick={handleDisabled}
                          />
                          <span>
                            I consent to having Beachcomber Hotels collect my
                            details via this form.
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center p-2">
                  {
                    islocked?  <span className={`size-small  text-red`}>Kindly provide your consent to complete the registration.</span>: null
                  }
               
                </div>
               
              </div>
            </div>
          </Col>
          <Col className="col-12 col-sm-5 col-md-5 col-lg-5 " id="registration-block">
            <div className="">
            <RegistrationForm isDisabled={isDisabled} handleDisabled={handleDisabled}/>
            </div>
            
          </Col>
        </Row>
        <div>
          <Footer islogin={false} />
        </div>
      </div>
    </div>
  );
}
